import {Component, OnInit, inject} from '@angular/core';
import {DebugService} from "./services/debug.service";
import {RouterOutlet} from "@angular/router";


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [
        RouterOutlet
    ]
})
export class AppComponent {
  logo = '';
  ico = '';
  title = '';
  message: string | null = null;

  private debug = inject(DebugService);

  constructor() {
  }

}
